/**
 * Domain-based Branding Configuration
 * 
 * This file contains branding configurations for different domains.
 * Each domain can have its own logo, colors, and favicon.
 */

// Import logo from images folder
import hamroLogo from "../images/hamro-logo.png";

const domainBrandingConfig = {
  // Hamro Production domain
  "hamrohealth.ptmantra.com": {
    logo: hamroLogo, // Logo from src/images folder
    logoBackgroundColor: "#FFFFFF", //Optional
    skin: {
      primaryColor: "#00a7d1",
      BrandColor: "#00a7d1", 
      favicon: hamroLogo, 
    },
  },
  // Hamro Staging domain
  "stage-hh.ptmantra.com": {
    logo: hamroLogo, 
    logoBackgroundColor: "#FFFFFF", 
    skin: {
      primaryColor: "#00a7d1",
      BrandColor: "#00a7d1", 
      favicon: hamroLogo, 
    },
  },
  // Localhost for testing (getCurrentDomain returns only hostname, not port)
  // "localhost": {
  //   logo: hamroLogo, // Logo for local testing
  //   logoBackgroundColor: "#FFFFFF", 
  //   skin: {
  //     BrandColor: "#00a7d1", 
  //     favicon: hamroLogo, 
  //   },
  // },
  // Default domains (dev.ptmantra.com, qa.ptmantra.com, stage.ptmantra.com, app.ptmantra.com)
  // do not need entries here - they will use API/default branding
};

export default domainBrandingConfig;

